<template>
  <div
    class="accruals-estimate-source-toggle"
    :class="[countClass, {
      'accruals-estimate-source-toggle--disabled': disabled,
      'accruals-estimate-source-toggle--faded': faded,
    }]"
    data-row-nav-ignore
    data-testid="accruals-estimate-source-toggle"
    @click.stop
  >
    <div
      class="accruals-estimate-source-toggle__thumb"
      :style="thumbStyle"
      aria-hidden="true"
      data-testid="accruals-estimate-source-toggle__thumb"
    />
    <button
      v-for="option in options"
      :key="option.id"
      type="button"
      class="accruals-estimate-source-toggle__btn"
      :class="{
        'accruals-estimate-source-toggle__btn--active': value === option.id,
        'accruals-estimate-source-toggle__btn--unavailable': option.disabled,
      }"
      :disabled="disabled || option.disabled"
      :data-testid="`accruals-estimate-source-toggle__btn--${option.id}`"
      @click.stop="onSelect(option.id)"
    >
      <img
        v-if="option.icon"
        :src="option.icon"
        alt=""
        class="accruals-estimate-source-toggle__icon"
      />
      <span class="accruals-estimate-source-toggle__label">{{ option.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AccrualsEstimateSourceToggle',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    faded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    optionCount() {
      return (this.options || []).length;
    },
    activeIndex() {
      const index = (this.options || []).findIndex((entry) => entry.id === this.value);
      return index >= 0 ? index : 0;
    },
    countClass() {
      if (this.optionCount === 2) return 'accruals-estimate-source-toggle--count-2';
      if (this.optionCount === 3) return 'accruals-estimate-source-toggle--count-3';
      return null;
    },
    thumbStyle() {
      const count = this.optionCount;
      const index = this.activeIndex;
      if (!count) return { display: 'none' };

      const segmentWidth = `calc((100% - 4px) / ${count})`;
      return {
        left: `calc(2px + ${index} * ((100% - 4px) / ${count}))`,
        width: segmentWidth,
      };
    },
  },
  methods: {
    onSelect(id) {
      const option = (this.options || []).find((entry) => entry.id === id);
      if (this.disabled || option?.disabled || id === this.value) return;
      console.log('[AccrualsEstimateSourceToggle]:', { source: id });
      this.$emit('input', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsEstimateSourceToggle.scss';
</style>
